module.exports = __webpack_public_path__ + "img/canceled.34cb82e2.svg";